export default {
  apply: [
    { id: 17000, clientId: 5486 }, // Preferred
    { id: 17001, clientId: 5524 }, // Preferred with Interest
    { id: 17002, clientId: 5522 }, // Four Star with Interest
    { id: 17003, clientId: 5502 }, // Interest
    { id: 17005, clientId: 5538 }, // Four Star
    { id: 17006, clientId: 5520 }, // Select
    { id: 17008, clientId: 5504 }, // Smart Start Banking
    { id: 17012, clientId: 5526 }, // Statement
    { id: 17014, clientId: 5514 }, // Holiday
    { id: 17015, clientId: 5528 }, // My Choice
    { id: 17018, clientId: 5530 }, // Cash Management
    { id: 17020, clientId: 5492 },  // Penalty Free CD
  ],
  credit: [
    { id: 17037, offerId: 'H54HV599VB'}, // Visa Platinum
    { id: 17038, offerId: '63DQ98V3GG'}, // Visa Everyday Rewards+ Card
    { id: 17039, offerId: '4D577B1Q56'}, // College Real Rewards
    { id: 17042, offerId: '86DH4WPV76'}, // Secured Visa
    { id: 17043, offerId: 'V83BHD538D'}, // Visa Signature Max
    { id: 17040, offerId: '3HMQ87X79G'}, // Cash Rewards
    { id: 17041, offerId: 'MV8221GV79'} // Premier Rewards
  ],
  loan: [
    {id: 17027}, // Total Line of Credit
    {id: 17029}, // Unsecured LOC
    {id: 17030} // Unsecured Personal
  ],
  mortgage: [
    // Removed as part of ST-186
  ],
  contact: [
    {id: 17023}, // Veteran Mortgage
    {id: 17026}, // First Time Home Buyer
    {id: 17022}, // Mortgage
    {id: 17025},  // Veteran Refi
    {id: 17024}, // Mortgage Refi
    {id: 17004}, // Armed Forces
    {id: 17007}, // Easy
    {id: 17009}, // Moola Moola
    {id: 17010}, // Minor Statement
    {id: 17011}, // Preferred
    {id: 17013}, // Passbook
    {id: 17016}, // Money Market
    {id: 17019}, // CD
    {id: 17021}, // S&T Bill CD
    {id: 17031}, // Auto Loan
    {id: 17032}, // Motorcycle Loan
    {id: 17033}, // Rec Vehicle Loan
    {id: 17034}, // Auto Loan Refi
    {id: 17035}, // Motorcycle Refi
    {id: 17036}  // Rec Vehicle Refi
  ]
};
